module.exports = __webpack_public_path__ + "2fcf0e15573494f140267901b92fb056.png";